<template>
  <!-- Add The Profile Card View here -->
  <base-card class="profile-card">
    <div class="row align-items-center ml-1 p-1">
      <div class="col-xs-3 offset-xs-3 pr-2">
        <img :src="currentUser.data.links.profile_picture_url" alt="Profile Picture" class="profile-icon" />
      </div>
      <div class="col-xs-6 align-self-start mt-3">
        <h3 class="card-title p-0 mb-1 full-name">{{ fullName }}</h3>
        <!-- Badge Contents -->
        <ul class="badge-list">
          <li>
            <base-badge class="badge-role mb-1">
              <span>{{ currentMember.attributes.role }}</span>
            </base-badge>
          </li>
          <li v-if="isOverdue">
            <base-badge class="badge-overdue">
              <font-awesome-icon :icon="['fas', 'alarm-exclamation']"></font-awesome-icon>
              <span> {{ $t('profileCard.overdue') }}</span>
            </base-badge>
          </li>
        </ul>
      </div>
    </div>
  </base-card>
</template>

<script>
import { mapState } from 'vuex';
import BaseCard from '../base-card/base-card.vue';

export default {
  name: 'ProfileCard',
  components: {
    BaseCard,
    BaseBadge: () => import('../base-badge/base-badge.vue'),
  },
  computed: {
    ...mapState(['currentCourse', 'currentActivities', 'currentUser', 'currentMember']),
    fullName() {
      if (this.currentUser) {
        return `${this.currentUser.data.attributes.first_name} ${this.currentUser.data.attributes.last_name}`;
      }
      return '';
    },
    isOverdue() {
      // method to check if any of the activities are overdue
      const currentDate = new Date();
      if (this.currentActivities) {
        return this.currentActivities.data.some((activity) => currentDate > new Date(activity.due_at) && !activity.meta.passed && !activity.meta.in_progress);
      }
      return false;
    },
  },
};
</script>

<style scoped lang="scss" src="./styles.scss">
</style>
